import React, { useState } from "react";
import AI102 from "../assets/certifications/ai-102.webp";
import AI900 from "../assets/certifications/ai-900.png";
import AZ900 from "../assets/certifications/az-900.png";
import Oraclecloud from "../assets/certifications/ORACLE.png";
import Gail from "../assets/certifications/gail.png";
import Loading from "./Loading";

const certifications = [
  { title: "Azure AI Engineer Associate", code: "AI-102", image: AI102 },
  { title: "Azure AI Fundamentals", code: "AI-900", image: AI900 },
  { title: "Azure Fundamentals", code: "AZ-900", image: AZ900 },
  {
    title: "Oracle Generative AI Professional",
    code: "1Z0-1127-25",
    image: Oraclecloud,
  },
  { title: "Google Generative AI Leader", code: "GAIL", image: Gail },
];

export default function CertificationsIcons() {
  const [loadedMap, setLoadedMap] = useState({});

  return (
    <section id="certificates" className="bg-gray-900 text-white pt-14">
      <div className="max-w-screen-x mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-6">
          {certifications.map((cert) => (
            <div
              key={cert.code}
              className="rounded-xl border border-white/10 bg-white/5 p-5 text-center hover:bg-white/10 transition"
            >
              <div className="relative h-40 w-40 mx-auto">
                {!loadedMap[cert.code] && (
                  <Loading className="absolute inset-0" sizeClass="h-14 w-14" />
                )}
                <img
                  src={cert.image}
                  alt={cert.title}
                  width={160}
                  height={160}
                  className={`h-40 w-40 mx-auto object-contain transition-opacity duration-300 ${
                    loadedMap[cert.code] ? "opacity-100" : "opacity-0"
                  }`}
                  loading="lazy"
                  decoding="async"
                  onLoad={() =>
                    setLoadedMap((prev) => ({ ...prev, [cert.code]: true }))
                  }
                  onError={() =>
                    setLoadedMap((prev) => ({ ...prev, [cert.code]: true }))
                  }
                />
              </div>
              <p className="text-xs text-gray-400 mt-1">{cert.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
